import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=4bf4ca0f&scoped=true&"
import script from "./UploadDocument.vue?vue&type=script&lang=js&"
export * from "./UploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4ca0f",
  null
  
)

export default component.exports